import { createContext } from 'react';

import { CaptchaAction } from '@percent/utility';

export type CaptchaContextValue = {
  isEnabled: boolean;
  getToken: (action: CaptchaAction) => Promise<string | undefined>;
  reset: () => void;
};

export const CaptchaContext = createContext<CaptchaContextValue>({
  isEnabled: false,
  getToken: async () => undefined,
  reset: () => undefined,
});
